import { render } from "./App.vue?vue&type=template&id=33423760&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=33423760&scoped=true&lang=css"

import exportComponent from "C:\\llx\\1-it\\mahjong-vue-PWA-PR\\mahjong-vue-PWA-PR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33423760"]])

export default __exports__